<template>
  <!-- 項目を追加・削除等改修する際はsignup-LTI.vueも同様に行う -->
  <div>
    <spacer :y="5"/>
    <div
      v-if="!flag.invalidUrl && !flag.existsUser"
      v-show="flag.readyShow">
      <contents-box title="利用者情報入力" id="confirm">
        <div :class="$style.wrapper">
          <div :class="$style.row">
            <div :class="$style.label_wrap">
              <p :class="$style.label">{{ helper.master && helper.master.labels && school ? helper.master.labels.organizationTypes[school.is_company] : (school ? (school.is_company ? '企業' : '学校') : '') }}名</p>
            </div>
            <div :class="$style.detail">
              <p :class="$style.school" v-if="school">{{ school.name }}</p>
            </div>
          </div>
          <!-- 利用者タイプを選択 -->
          <!-- 選択内容によって入力項目変化 -->
          <div :class="$style.row">
            <div :class="$style.label_wrap">
              <p :class="$style.label">利用者種別</p>
              <p :class="$style.required">※必須項目</p>
            </div>
            <div :class="$style.detail">
              <ul :class="$style.radio">
                <li v-for="(opt, i) in accountType" :key="opt">
                  <!-- 企業（is_corporate）では種別「企業担当者」を一旦非表示にする。accountType の定義は温存しているので、復活時はこの条件を外すだけでよい -->
                  <div v-if="!(school && school.is_company && opt.name === 'parent') && !(isCorporate && opt.name === 'teacher')">
                    <input
                      type="radio"
                      name="account_type"
                      :id="opt.name"
                      :disabled="flag.isConfirm || flag.alreadySet"
                      :checked=" i === 0"
                      v-on:change="updateType">
                    <label :for="opt.name">{{ optLabel(opt) }}</label>

                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div v-if="school && school.is_company === 0 && userType === 1" :class="$style.row">
            <div :class="$style.label_wrap">
              <p :class="$style.label">学年</p>
              <p :class="$style.required">※必須項目</p>
            </div>
            <div :class="detail">
              <select
                :class="$style.select_box"
                v-model="schoolYear"
                name="schoolYear"
                id="schoolYear"
                :disabled="flag.isConfirm || flag.alreadySet">
                <option :value="null">選択してください</option>
                <option v-for="n of setSchoolYear()"
                  :key="n"
                  :value="n">{{ n }}</option>
                <!-- ↓ 自動学年繰上げで高校4年生等になってしまった場合表示されなくなってしまうため -->
                <option v-if="schoolYear > setSchoolYear()">{{ schoolYear }}</option>
              </select>
            </div>
          </div>

          <!-- 全タイプ必須の情報 -->
          <div :class="$style.row" v-for="row in contents" :key="row">
            <div :class="$style.label_wrap">
              <p :class="$style.label">{{ row.label }}</p>
              <p v-if="row.required" :class="$style.required">※必須項目</p>
            </div>


            <!-- テキスト -->
            <div :class="$style.detail" v-if="row.type === 'text'">
              <div>
                <!-- <input
                  v-if="row.name === 'username' || row.name === 'kana'"
                  :class="$style.text"
                  :name="row.name"
                  :disabled="flag.isConfirm || flag.alreadySet"
                  :placeholder="flag.isConfirm ? '' : row.placeholder"
                  v-model="row.value"
                  type="text"> -->
                <p
                  v-if="(row.name === 'username' || row.name === 'kana')
                    && (flag.isConfirm || flag.alreadySet)"
                  :class="[$style.text, $style.ptag]">{{ row.value }}</p>

                <input
                  v-else-if="row.name === 'kana'"
                  :class="$style.text"
                  :name="row.name"
                  :disabled="flag.isConfirm || flag.alreadySet"
                  :placeholder="flag.isConfirm ? '' : row.placeholder"
                  v-model.trim="$v.kana.$model"
                  v-on:input="onKanaInput(row, $v.kana.$model, $v.kana.$invalid)"
                  @compositionend="onKanaCompositionEnd(row)"
                  @blur="onKanaCompositionEnd(row)"
                  type="text">
                <input
                  v-else
                  :class="$style.text"
                  :name="row.name"
                  :disabled="flag.isConfirm || flag.alreadySet"
                  :placeholder="flag.isConfirm ? '' : row.placeholder"
                  v-model="row.value"
                  type="text">
              </div>
              <p :class="$style.assistant" v-if="!flag.isConfirm">{{ row.assistant }}</p>
              <p v-if="row.name === 'kana'&& $v.kana.$dirty && $v.kana.custom.$invalid" :class="$style.error">カナ文字のみ入力してください</p>
            </div>

            <!-- ラジオボタン -->
            <div :class="$style.detail" v-if="row.type === 'radio'">
              <ul :class="$style.radio">
                <li v-for="opt in row.options" :key="opt">
                  <input
                    type="radio"
                    :name="row.name"
                    :id="opt.name"
                    v-if="!flag.isConfirm"
                    :disabled="flag.isConfirm"
                    :checked="opt.value === row.value"
                    v-on:change="updateValue">
                  <label :for="opt.name" v-if="opt.value === row.value || !flag.isConfirm">{{ opt.label }}</label>
                </li>
              </ul>
            </div>

            <!-- 生年月日 -->
            <!-- 各 select の先頭 option は選択済みの値を再掲するためのもので、一度選ぶと同じ数字の option が 2 つ並ぶ。
                 月・日は先頭側が 0 埋め済みの値（'03'）・v-for 側が素の数値（3）と表記が割れるが、
                 どちらを選んでも updateValue が 0 埋めに正規化する（年は 4 桁なのでどちらも同じ値） -->
            <div :class="$style.detail" v-if="row.type === 'birthday'">
              <ul :class="$style.select_wrap">
                <li>
                  <select
                    :class="$style.select"
                    name="birthday"
                    id="year"
                    :disabled="flag.isConfirm"
                    v-on:change="updateValue">
                    <option
                      v-if="userBirthDay.year"
                      :value="userBirthDay.year">{{userBirthDay.year}}</option>
                    <option
                      v-if="!userBirthDay.year"
                      :value="0"></option>
                    <option
                      v-for="n of 70"
                      :key="n"
                      :value="optionYear(n)">{{ optionYear(n) }}</option>
                  </select>年
                </li>
                <li>
                  <select
                    :class="$style.select"
                    name="birthday"
                    id="month"
                    :disabled="flag.isConfirm"
                    v-on:change="updateValue">
                    <option
                      v-if="userBirthDay.month">{{userBirthDay.month}}</option>
                    <option
                      v-if="!userBirthDay.month"
                      :value="0"></option>
                    <option
                      v-for="n of 12"
                      :key="n"
                      :value="n">{{ n }}</option>
                  </select>月
                </li>
                <li>
                  <select
                    :class="$style.select"
                    name="birthday"
                    id="day"
                    :disabled="flag.isConfirm"
                    v-on:change="updateValue">
                    <option
                      v-if="userBirthDay.day"
                      :value="userBirthDay.day">{{userBirthDay.day}}</option>
                    <option
                      v-if="!userBirthDay.day"
                      :value="0"></option>
                    <option
                      v-for="n of 31"
                      :key="n"
                      :value="n">{{ n }}</option>
                  </select>日
                </li>
              </ul>
            </div>
          </div>

          <div :class="$style.row">
            <div :class="$style.label_wrap">
              <p :class="$style.label">住所</p>
              <p :class="$style.required">※必須項目</p>
            </div>
            <div :class="$style.detail">
              <spacer :y="2"/>
              <Address
                :items="items"
                :isConfirm="flag.isConfirm"
                v-on:sendValue="receiveValue"/>
            </div>
          </div>

          <div :class="$style.row">
            <div :class="$style.label_wrap">
              <p :class="$style.label">メールアドレス</p>
              <p :class="$style.required">※必須項目</p>
            </div>
            <div :class="$style.detail">
              <div>
                <!-- <input
                  :class="$style.text"
                  placeholder="メールアドレス"
                  id="mail"
                  type="email"
                  name="mail"
                  v-model="mail"
                  disabled> -->
                <p
                  :class="[$style.text, $style.ptag]">{{ mail }}</p>
              </div>
            </div>
          </div>

          <div :class="$style.row">
            <div :class="$style.label_wrap">
              <p :class="$style.label">パスワード</p>
              <p :class="$style.required">※必須項目</p>
            </div>
            <div :class="$style.detail">
              <div :class="$style.password_wrap">
                <input
                  :class="[$style.text, $style.password_field]"
                  placeholder="パスワード"
                  :disabled="flag.isConfirm"
                  :type="showPassword ? 'text' : 'password'"
                  id="password"
                  name="password"
                  v-model.trim="$v.password.$model"
                  v-on:input="invalidsCheck('password', $v.password.$invalid)">
                <i
                  v-if="!flag.isConfirm"
                  :class="[$style.toggle_password, showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye']"
                  @click="showPassword = !showPassword"
                  ></i>
                <p
                  :class="$style.error"
                  v-if="$v.password.$dirty
                    && $v.password.minLength.$invalid">パスワードは8文字以上で設定してください</p>
                <p
                  :class="$style.error"
                  v-if="$v.password.$dirty
                    && $v.password.maxLength.$invalid">パスワードは15文字以下で設定してください</p>
              </div>
              <p :class="$style.assistant" v-if="!flag.isConfirm">半角英数字8桁以上15桁以下</p>
            </div>
          </div>

          <div :class="$style.row">
            <div :class="$style.label_wrap">
              <p :class="$style.label">携帯番号</p>
            </div>
            <div :class="$style.detail">
              <div>
                <input
                  :class="$style.text"
                  type="text"
                  v-model="tel"
                  :disabled="flag.isConfirm">
              </div>
              <p :class="$style.assistant" v-if="!flag.isConfirm">半角・ハイフンなしで入力してください</p>
            </div>
          </div>
        </div>

        <div :class="$style.wrapper"
          v-if="userType === 1">
          <div :class="$style.row"
            v-for="row in studentItem"
            :key="row">
            <div :class="$style.label_wrap">
              <p :class="$style.label">{{ school && school.is_company && row.companyLabel ? row.companyLabel : row.label }}</p>
              <p v-if="row.required" :class="$style.required">※必須項目</p>
            </div>
            <!-- セレクト -->
            <div :class="$style.detail" v-if="row.type === 'select'">
              <select
                :class="$style.select"
                :name="row.name"
                :id="row.name"
                :disabled="flag.isConfirm"
                v-on:change="updateSchool">
                <option :value="0" :selected="row.value === 0">選択してください</option>
                <option
                  v-for="n of row.options"
                  :key="n"
                  :value="n.id"
                  :selected="n.id === row.value">{{ n.name }}</option>
              </select>
            </div>
            <!-- テキスト -->
            <div :class="$style.detail" v-if="row.type === 'text'">
              <div>
                <input
                  :class="$style.text"
                  :name="row.name"
                  :disabled="flag.isConfirm"
                  :placeholder="flag.isConfirm ? '' : (school && school.is_company && row.companyPlaceholder ? row.companyPlaceholder : row.placeholder)"
                  v-model="row.value"
                  type="text">
              </div>
              <p :class="$style.assistant" v-if="!flag.isConfirm">{{ row.assistant }}</p>
            </div>
          </div>
        </div>

        <div :class="$style.wrapper"
          v-if="userType === 2">
          <div :class="$style.row"
            v-for="row in parentItem"
            :key="row">
            <div :class="$style.label_wrap">
              <p :class="$style.label">{{ row.label }}</p>
              <p v-if="row.required" :class="$style.required">※必須項目</p>
            </div>
            <!-- テキスト -->
            <div :class="$style.detail" v-if="row.type === 'text'">
              <div>
                <input
                  :class="$style.text"
                  :name="row.name"
                  :disabled="flag.isConfirm"
                  :placeholder="flag.isConfirm ? '' : row.placeholder"
                  v-model="row.value"
                  type="text">
              </div>
              <p :class="$style.assistant" v-if="!flag.isConfirm">{{ row.assistant }}</p>
            </div>
          </div>
        </div>

        <div :class="$style.wrapper"
          v-if="userType === 3">
          <div :class="$style.row"
            v-for="row in teacherItem"
            :key="row">
            <div :class="$style.label_wrap">
              <p :class="$style.label">{{ (school && school.is_company) && row.companyLabel ? row.companyLabel : row.label }}</p>
              <p v-if="row.required" :class="$style.required">※必須項目</p>
            </div>
            <!-- セレクト -->
            <div :class="$style.detail" v-if="row.type === 'select'">
              <select
                :class="$style.select"
                :name="row.name"
                :id="row.name"
                :disabled="flag.isConfirm"
                v-on:change="updateSchool">
                <option
                  v-for="n of row.options"
                  :key="n"
                  :value="n.value">{{ n.label }}</option>
              </select>
            </div>
            <!-- テキスト -->
            <div :class="$style.detail" v-if="row.type === 'text'">
              <div>
                <input
                  :class="$style.text"
                  :name="row.name"
                  :disabled="flag.isConfirm"
                  :placeholder="flag.isConfirm ? '' : row.placeholder"
                  v-model="row.value"
                  type="text">
              </div>
              <p :class="$style.assistant" v-if="!flag.isConfirm">{{ row.assistant }}</p>
            </div>
          </div>
        </div>

        <div :class="$style.wrapper" v-if="flag.isConfirm">
          <div :class="$style.row">
            <div :class="$style.label_wrap">
              <p :class="$style.label">利用規約</p>
            </div>
            <div :class="$style.detail">
              <div :class="$style.terms">
                <terms
                  isSignup="true"
                  :schoolId="schoolId"
                  :isCompany="school && school.is_company ? 1 : 0"
                  :isCorporate="isCorporate ? 1 : 0" />
              </div>

              <spacer :y="2" />
              <ul :class="$style.checkbox_wrap">
                <li :class="$style.parentAgree" v-if="isMinor">
                  <input
                    type="checkbox"
                    id="parent_agree"
                    name="parent"
                    v-on:change="changeAgrees"
                    :checked="agrees.parent">
                  <label for="parent_agree">未成年（18歳未満）の方は、本サービスの利用にあたり保護者の同意を得ています。</label>
                </li>
                <li :class="$style.agree">
                  <input
                    type="checkbox"
                    id="agree"
                    name="agree"
                    v-on:change="changeAgrees"
                    :checked="agrees.agree">
                  <label for="agree">利用規約に同意して登録する</label>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <spacer :y="5"/>
        <btn-container>
          <basic-btn
            tag="button"
            v-if="!flag.isConfirm"
            v-on:click="changeFlag">入力内容を確認する</basic-btn>
          <basic-btn
            tag="button"
            v-if="flag.isConfirm"
            v-on:click="changeFlag">編集画面に戻る</basic-btn>
          <spacer :x="2"/>
          <basic-btn
            tag="button"
            v-if="flag.isConfirm"
            :disabled="!agrees.parent || !agrees.agree"
            v-on:click="regist">入力内容を確定する</basic-btn>
        </btn-container>
      </contents-box>
    </div>
    <div v-else-if="flag.existsUser">
      <div :class="$style.message">
        <p :class="$style.logo"><img src="@/assets/images/logo_vertical.png" alt="welcome to talk"></p>
        <p>「{{ this.mail }}」のメールアドレスは利用者登録済みです。</p>
        <p><router-link to="/login/">ログインページ</router-link>よりログインのうえご利用ください。</p>
      </div>
    </div>
    <div v-else-if="flag.invalidUrl">
      <div :class="$style.message">
        <p :class="$style.logo"><img src="@/assets/images/logo_vertical.png" alt="welcome to talk"></p>
        <p>URLが無効です。URLを確認してください。</p>
        <p><router-link to="/login/">ログインページ</router-link></p>
      </div>
    </div>
    <spacer :y="8.5"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { calcAgeFromParts } from '@/lib/dateParts';
import { ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, maxLength } from '@vuelidate/validators';
import BasicBtn from '@/views/components/BasicBtn.vue';
import BtnContainer from '@/views/components/BtnContainer.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import Spacer from '@/views/components/Spacer.vue';
import { Address } from '@/views/components/parts/Form';
import { normalizeKana, isValidKana } from '@/lib/normalizeKana';
import Terms from '@/views/pages/Common/Terms.vue';
import cf from '@/mixins/commonFunctions.js';
import corporateSchool from '@/mixins/corporateSchool.js';

export default {
  name: 'signup2',
  mixins: [cf, corporateSchool],
  components: {
    BasicBtn,
    BtnContainer,
    ContentsBox,
    Spacer,
    Address,
    Terms,
  },
  setup() {
    const password = ref('');
    const kana = ref('');
    const showPassword = ref(false);

    // カタカナ・半角スペース・全角スペースのみ許す
    const kanaTextRule = (value) => /^[ァ-ヶー\s　]+$/u.test(value);

    const rules = {
      // パスワードは必須
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(15),
      },
      kana: {
        required,
        custom: kanaTextRule,
      },
    };

    const $v = useVuelidate(rules, { password, kana });

    return {
      password,
      kana,
      showPassword,
      $v,
    };
  },
  data() {
    return {
      mail: null, // qrCustomerから取得
      flag: {
        readySubmit: false,
        isConfirm: false,
        invalidUrl: false,
        readyShow: false,
        existsUser: false,
        alreadySet: false,
      },
      validationFlags: {
        password: false,
        kana: false,
      },
      invalids: {
        password: true,
        minLength: true,
        kana: true,
      },
      agrees: {
        parent: false,
        agree: false,
      },
      school: null,
      userDetail: null,
      tel: null,
      address: {},
      additional: ['school', 'school_year', 'student_number'],
      userType: 1,
      schoolYear: null,
      accountType: [
        {
          name: 'student',
          label: '生徒',
          companyLabel: 'プログラム参加者',
          corporateLabel: '社員',
          value: 1,
        },
        {
          name: 'parent',
          label: '保護者',
          companyLabel: '',
          value: 2,
        },
        {
          name: 'teacher',
          label: '教職員',
          companyLabel: '企業担当者',
          value: 3,
        },
      ],
      contents: [
        {
          type: 'text',
          name: 'username',
          label: '名前',
          required: true,
          placeholder: '例：三上 春斗',
          value: '',
        },
        {
          type: 'text',
          name: 'kana',
          label: 'フリガナ',
          required: true,
          placeholder: '例：ミカミ ハルト',
          value: '',
        },
        {
          type: 'radio',
          name: 'gender',
          label: '性別',
          required: true,
          value: null,
          options: [
            {
              name: 'male',
              label: '男性',
              value: 1,
            },
            {
              name: 'female',
              label: '女性',
              value: 2,
            },
            {
              name: 'other',
              label: 'その他',
              value: 3,
            },
          ],
        },
        {
          type: 'birthday',
          name: 'birthday',
          label: '生年月日',
          required: true,
          values: {
            year: null,
            month: null,
            day: null,
          },
        },
      ],
      studentItem: [],
      parentItem: [],
      teacherItem: [
        {
          name: 'route',
          type: 'text',
          label: '経路',
          companyLabel: '特記事項',
          value: null,
        },
      ],
      items: [
        {
          name: 'zip',
          type: 'text',
          label: '郵便番号',
          value: null,
          required: true,
          placeholder: '1020074',
          comment: '半角・ハイフンなしで入力してください',
        },
        {
          name: 'pref',
          type: 'select',
          label: '都道府県',
          value: null,
          options: [],
          required: true,
          comment: '',
        },
        {
          name: 'city',
          type: 'text',
          label: '市区町村',
          value: null,
          required: true,
          placeholder: '千代田区九段南',
        },
      ],
    };
  },
  created() {
    const query = this.$route.query;
    if (query) {
      if (query.school) {
        this.schoolId = Number(query.school);
        this.getSchool();
      }
      if (!query.school || !query.customer) {
        this.flag.invalidUrl = true;
      }
    }

    if (this.helper.master.prefs) {
      this.items[1].options = this.helper.master.prefs;
    } else {
      this.$store.subscribe((mutations) => {
        if (mutations.type === 'helper/putMaster') {
          this.items[1].options = mutations.payload.prefs;
        }
      });
    }
  },
  computed: {
    ...mapState(['user', 'helper']),
    // 年齢の算出は共通ヘルパーに集約している（未入力・プレースホルダ option・存在しない日付は null）。
    // ヘルパーは日本時間の暦日で判定するので、端末のタイムゾーン設定によって
    // 保護者同意ゲートの出方が変わることはない。
    calcAge() {
      let values = null;
      this.contents.some((r) => {
        if (r.name === 'birthday') {
          values = r.values;
        }
        return false;
      });
      return calcAgeFromParts(values);
    },
    // 保護者同意の対象者ゲート単一軸。年齢不明（null）は未成年側に倒す＝欄を表示して手動同意を必須にする fail-safe。
    // 従来は表示側 calcAge < 18 と自動同意側 calcAge > 17 の逆向き述語に割れており、
    // null が両方で未成年側に倒れて「欄は出るが自動同意もされない」＝確定不能になっていた
    isMinor() {
      return this.calcAge === null || this.calcAge < 18;
    },
    userBirthDay() {
      return this.contents[3].values;
    },
    // 所属組織が企業（is_company かつ is_corporate）か
    isCorporate() {
      return this.isCorporateSchool(this.school ? [this.school] : null);
    },
  },
  methods: {
    // 利用者種別ラベルを組織区分で出し分け（企業=社員 / インターン=companyLabel据置 / 学校=label）
    optLabel(opt) {
      if (this.isCorporate && opt.corporateLabel) return opt.corporateLabel;
      return this.school && this.school.is_company ? opt.companyLabel : opt.label;
    },
    // masterのデータから該当する学校の学年を取得
    setSchoolYear() {
      if (this.school) {
        const school = this.school;
        const yearIndex = Object.keys(this.helper.master.schoolYear).findIndex((elem) => this.helper.master.schoolYear[elem].label === school.school_type);
        const schoolYear = this.helper.master.schoolYear[yearIndex].value;
        return schoolYear;
      }
    },
    optionYear(n) {
      const year = Number(this.formatTimestamp(new Date(), 'YYYY')) + 1 - n;
      return year;
    },
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    getSchool() {
      const params = {
        id: this.schoolId,
        isUsers: 0,
        isAddress: 0,
        isMainUser: 0,
      };
      const query = this.$route.query;

      this.axios({
        method: 'GET',
        url: '/v1/school/get/detail',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.school = res.detail;
          if (query.customer) {
            this.customerId = Number(query.customer);
            if (this.school.billing_type.billing_type === 1) { // 従量課金モデルの場合
              this.getQrCustomer();
            } else { // アカウント課金モデルの場合
              this.getAccountCustomer();
            }
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          this.flag.invalidUrl = true;
        });
    },
    /** 従量課金モデルの本登録対象ユーザー取得 */
    getQrCustomer() {
      this.axios({
        method: 'GET',
        url: '/v1/qrCustomer/get/detail',
        params: {
          id: this.customerId,
        },
      })
        .then((response) => {
          this.mail = response.data.detail.email;
          // 本登録しているかの確認
          this.getUser();
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          this.flag.invalidUrl = true;
        });
    },

    getUser() {
      this.axios({
        method: 'GET',
        url: '/v1/user/get/detail',
        params: {
          email: this.mail,
          // includeDeleted: 1,
        },
      })
        .then((response) => {
          if (response.data.data) {
            // 本登録が完了している場合はその旨表示
            this.flag.existsUser = true;
            console.log(this.flag.existsUser);
          }
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        })
        .finally(() => {
          this.flag.readyShow = true;
        });
    },

    // 名前に特殊文字が入っていた際は変換して表示
    judgChar(name) {
      let result;
      if (name.includes('&#x') && name.includes(';')) { // 特殊文字のコードを変換
        result = name.replace('&#x', '*'); // インデックス取得用マーカー
        result = result.replace(';', '');
        const targetIndex = result.indexOf('*'); // マーカーのインデックスを取得
        result = result.replace('*', ''); // 開始位置を特定したら不要なので削除
        const hexString = result.slice(targetIndex, targetIndex + 4); // 16進数の文字コードを切り出し
        const hexIndex = result.indexOf(hexString);
        result = result.replace(hexString, '');
        const decrypt = String.fromCharCode(parseInt(hexString, 16));
        result = result.slice(0, hexIndex) + decrypt + result.slice(hexIndex, result.length); // 元の位置に戻す
      } else {
        result = name;
      }
      return result;
    },

    /** アカウント課金モデルの本登録対象ユーザー取得 */
    getAccountCustomer() {
      const query = this.$route.query;

      this.axios({
        method: 'GET',
        url: '/v1/user/get/detail',
        params: { id: query.customer },
      })
        .then((response) => {
          this.userDetail = response.data.data;
          /** 規定値をセット */
          const userData = response.data.data;
          if (userData && userData.school_year && this.school && this.school.is_company === 0) {
            this.schoolYear = userData.school_year;
          }
          this.contents[0].value = this.judgChar(userData.username);
          this.contents[1].value = userData.kana;
          this.mail = userData.email;
          this.flag.alreadySet = true;
          // カナが既にセット済みならバリデーションをパスさせる
          if (userData.kana) {
            this.invalids.kana = false;
          }
          this.accountType = [
            {
              name: 'student',
              label: '生徒',
              companyLabel: 'プログラム参加者',
              corporateLabel: '社員',
              value: 1,
            },
          ];
        })
        .catch((error) => {
          console.log(error);
          this.flag.invalidUrl = true;
        })
        .finally(() => {
          this.flag.readyShow = true;
        });
    },
    /** 無効フラグの更新 */
    invalidsCheck(name, bool) {
      this.invalids[name] = bool;
    },
    /** カナ入力時にrow.valueへ同期しつつバリデーションチェック */
    onKanaInput(row, model, invalid) {
      row.value = model;
      this.invalidsCheck('kana', invalid);
    },
    /** kana: IME 確定後・blur 時に normalize（入力アシスト）
     *  required + custom 相当を直接判定（空入力 or 不正値で invalid） */
    onKanaCompositionEnd(row) {
      const normalized = normalizeKana(this.kana);
      this.kana = normalized;
      row.value = normalized;
      this.invalidsCheck('kana', !normalized || !isValidKana(normalized));
    },
    /** 子から値を受け取る */
    receiveValue(values) {
      this.flag.readySubmit = values.readySubmit;
      this.address = values.address;
    },
    updateType(e) {
      this.accountType.forEach((row) => {
        if (e.target.id === row.name) {
          this.userType = row.value;
        }
      });
      if (this.userType !== 1) this.schoolYear = null;
    },
    updateValue(e) {
      // ラジオボタン
      if (e.target.type === 'radio') {
        this.contents.forEach((row) => {
          if (row.name === e.target.name) {
            row.options.forEach((opt) => {
              if (e.target.id === opt.name) {
                row.value = opt.value;
              }
            });
          }
        });
      }
      if (e.target.type === 'select-one') {
        this.contents.forEach((row) => {
          if (row.name === e.target.name) {
            // この値は年齢算出と送信値 birthday の両方に渡る。送信値は年月日を文字列連結して
            // 組み立てるので、1 桁を 0 埋めしないと ISO 形式にならず、日付パースが
            // ブラウザのエンジン実装依存になる。
            // 桁数で判定するので、既に 0 埋め済みの選択済み option を選び直しても二重 0 埋めにならない（冪等）
            row.values[e.target.id] = String(e.target.value).length === 1 ? `0${e.target.value}` : `${e.target.value}`;
          }
        });
      }
    },
    updateSchool(e) {
      if (this.userType === 1) this.studentItem[0].value = Number(e.target.value);
      else if (this.userType === 3) this.teacherItem[0].value = Number(e.target.value);
    },
    changeFlag() {
      // 18歳以上の場合は保護者同意不要（表示ゲートと同一の isMinor を参照して軸を揃える）
      if (!this.isMinor) this.agrees.parent = true;
      if (!this.flag.isConfirm) {
        // 必須項目が入力されているか確認
        // 共通項目
        let filledRequired = true;
        this.contents.forEach((row) => {
          if (row.required) {
            if (row.name === 'birthday') {
              Object.keys(row.values).forEach((key) => {
                // 0 埋め後の '00'（プレースホルダ option を選んだ状態）は文字列として truthy に
                // なるため、数値化してから判定する
                if (!Number(row.values[key])) filledRequired = false;
              });
            } else if (row.value === null || row.value === '') {
              filledRequired = false;
            }
          }
        });

        // 各タイプごとの確認
        let checkArray = [];
        if (this.userType === 1) checkArray = this.studentItem;
        else if (this.userType === 2) checkArray = this.parentItem;
        else if (this.userType === 3) checkArray = this.teacherItem;
        checkArray.forEach((row) => {
          if (row.required) {
            if (row.value === null || row.value === '' || !row.value) {
              filledRequired = false;
            }
          }
        });

        // 学年確認
        if (this.school.is_company === 0) {
          if (this.userType === 1) {
            if (!this.schoolYear) {
              filledRequired = false;
            }
          }
        }

        if (!filledRequired) {
          alert('必須項目が未入力です。');
          return;
        }
        if (!this.flag.readySubmit) {
          alert('住所を正しく入力してください');
          return;
        }
        const errors = [];
        if (this.invalids.mail) errors.push('メールアドレスが正しく入力されていません');
        if (this.invalids.password) errors.push('パスワードが正しく入力されていません');
        if (this.invalids.kana) errors.push('フリガナはカナ文字のみで入力してください');
        if (errors.length) {
          alert(`以下の項目を確認してください。\n${errors.map((e) => `・${e}`).join('\n')}`);
          return;
        }

        // 必須項目が入力されていたら進む
        this.flag.isConfirm = !this.flag.isConfirm;
        const elem = document.getElementById('confirm');
        const position = elem.getBoundingClientRect().top;
        scrollBy(0, position - 77);
      } else {
        // 確認画面から編集に戻る際はagreesをリセット
        this.agrees.parent = false;
        this.agrees.agree = false;
        this.flag.isConfirm = !this.flag.isConfirm;
      }
    },
    regist() {
      this.showLoading();

      const data = {
        additionalData: {},
      };

      // 共通の項目
      this.contents.forEach((row) => {
        if (row.name === 'birthday') {
          data.birthday = `${row.values.year}-${row.values.month}-${row.values.day}`;
        } else {
          data[row.name] = row.value;
        }
      });
      data.account_type = this.userType;
      data.school_year = this.schoolYear;
      data.email = this.mail;
      data.password = this.password;
      data.tel = this.tel;

      // 住所
      data.addressData = this.address;
      data.addressData.model_type = 1;

      // 各タイプごとの項目(additionalData)
      let setArray = [];
      if (this.userType === 1) setArray = this.studentItem;
      if (this.userType === 2) setArray = this.parentItem;
      if (this.userType === 3) setArray = this.teacherItem;
      setArray.forEach((row) => {
        data.additionalData[row.name] = row.value;
      });

      // 連関テーブル(organizationData)
      const userOrganization = {
        organization_type: 1, // 学校との連関は1
        foreign_id: this.schoolId,
      };
      data.organizationData = userOrganization;

      // 仮登録フラグを0にする
      // data.temporary = 0;

      this.axios({
        method: 'POST',
        url: '/v1/user/set/register',
        data,
      })
        .then((response) => {
          // 登録済みEmailへ連絡
          this.contact(response.data.userEmail);
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
          // バックエンドのバリデーションエラー（フリガナ等）メッセージがあれば表示
          const serverMessage = error.response && error.response.data && error.response.data.message;
          if (serverMessage) alert(serverMessage);
          this.hideLoading();
        });
    },

    contact(userEmail) {
      this.axios({
        method: 'POST',
        url: '/v1/contact/registed/user',
        data: { email: userEmail },
      })
        .then((response) => {
          console.log(response.data);
          alert('利用者登録が完了しました。\nログイン画面へリダイレクトします。');
          this.hideLoading();
          this.$router.push('/login/');
        })
        .catch((error) => {
          if (error.message) console.log(error.message);
          else console.log(error);
        });
    },

    changeAgrees(e) {
      const tgt = e.currentTarget;
      const name = tgt.name;
      const checked = tgt.checked;
      this.agrees[name] = checked;
    },
  },
};
</script>

<style lang="scss" module>
.row {
  padding: 24px 0;
  border-top: 1px solid var(--gray-main);
}
.label {
  border-radius: 4px;
  margin-right: 4px;
  font-weight: bold;
  display: inline-block;
  &_wrap {
    display: flex;
    align-items: baseline;
  }
}

.school {
  margin-top: 7px;
}
.text, .select {
  &:disabled,
  &.ptag {
    color: black;
    background-color: transparent;
    &:-webkit-autofill {
      box-shadow: 0 0 0 100px white inset;
    }
  }
  &.ptag {
    overflow-wrap: anywhere;
    word-break: normal;
    line-break: strict;
  }
}
.select_box {
  padding: 13px;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  border-radius: 8px;
  appearance: none;

  &_wrap {
    display: flex;

    li {
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
}
.required {
  font-size: 12px;
  color: var(--pink);
}
.assistant {
  font-size: 12px;
}
.error {
  font-size: 12px;
  color: var(--pink);
}
.password_wrap {
  position: relative;
}
.password_field {
  padding-right: 45px !important;
}
.toggle_password {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999;
  font-size: 18px;
}
.space {
  padding-top: 6px;
}
.text {
  width: 100%;
  padding: 13px;
  border-radius: 8px;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  $background: var(--gray-sub);
  &:-webkit-autofill {
    box-shadow: 0 0 0 100px $background inset;
  }
  &.ptag {
  }
}
.radio {
  padding-top: 8px;
  display: flex;

  li {
    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-right: 20px;
    }
  }
}
.select {
  padding: 13px;
  background-color: var(--gray-sub);
  border: none;
  outline: none;
  border-radius: 8px;

  &_wrap {
    display: flex;

    li {
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
}
.tel {
  width: 70px;
  padding: 13px;
}
.terms {
  height: 295px;
  padding: .5em 1em;
  border: 1px solid #ccc;
  overflow-y: scroll;
  border-radius: 10px;
}
.checkbox_wrap {
  font-size: 13px;
  > li {
    padding: .5em;
    &:not(:first-child) {
      margin-top: 5px;
    }
    &.parentAgree {
      background-color: rgba(#60b2c1, .3);
    }
    &.agree {
      background-color: rgba(#e7a223, .3);
    }
  }
}

.message {
  .logo {
    margin: 2em 0 4em;
  }
  img {
    display: block;
    max-width: 400px;
    width: 80%;
    margin: 0 auto;
  }
  p {
    line-height: 1.8;
    text-align: center;
  }
  a {
    text-decoration: underline;
  }
}
</style>
